export const ALERT_TITLE_KEY = "alertTitle";
export const ALERT_MESSAGE_KEY = "alertMessage";
export const ALERT_COLOR_KEY = "alertColor";
export const ALERT_DISCLAIMER_KEY = "alertDisclaimer";

export type AlertState = {
  [ALERT_TITLE_KEY]?: string;
  [ALERT_MESSAGE_KEY]?: string | string[];
  [ALERT_DISCLAIMER_KEY]?: string;
  [ALERT_COLOR_KEY]?: "warning" | "success" | "info";
};
